const routes = {
  LOGIN: '/login',
  LAYOUT: '/*',
  ERROR: '/error',
  FIRST_FEATURE: '/first-feature',
  SECOND_FEATURE: '/second-feature',
  MATCH_MAKER: '/matchmaker',
  MATCH_MAKER_OUTPUT_MATERIALS: '/matchmaker/output-materials',
  MATCH_MAKER_PRODUCTION_CONSUMPTION:
    '/matchmaker/output-materials/:materialId/components',
  MATCH_MAKER_MATCH_WITH_SOFTTAG:
    '/matchmaker/output-materials/:materialId/components/:componentId/soft-tag',
  MATCH_MAKER_MATERIAL_STOCK_RECONCILIATION:
    '/matchmaker/material-stock-reconciliation',
  PRODUCTION_REPORTING: '/reporting/lines',
  PRODUCTION_REPORTING_ADD_PERIODS: '/reporting/lines/:lineId/periods',
  PRODUCTION_REPORTING_REVIEW_PERIODS:
    '/reporting/lines/:lineId/periods/:pid/:materialId',
  STOCK_RECONCILIATION: '/stock-reconciliation',
};

export const NonIsolationScreens = [
  '/',
  routes.MATCH_MAKER,
  routes.PRODUCTION_REPORTING,
  routes.STOCK_RECONCILIATION,
  routes.MATCH_MAKER_MATERIAL_STOCK_RECONCILIATION,
];

export const SidebarRoutes = [
  {
    id: 'home',
    text: 'Home',
    icon: 'Home',
    selected: true,
    iconTrailing: 'Home',
    url: '/',
  },
  {
    id: 'matchmaker',
    text: 'Matchmaker',
    icon: 'DoubleArrows',
    selected: true,
    iconTrailing: 'DoubleArrows',
    url: routes.MATCH_MAKER,
  },
  {
    id: 'production-reporting',
    text: 'Production reporting',
    icon: 'Article',
    selected: true,
    iconTrailing: 'Article',
    url: routes.PRODUCTION_REPORTING,
  },
  {
    id: 'reconciliation',
    text: 'Reconciliation',
    icon: 'Boundary',
    selected: true,
    iconTrailing: 'Boundary',
    url: routes.STOCK_RECONCILIATION,
    disabled: true,
  },
];

export default routes;
